import axios from 'axios'

export default {
    getOrders(page, filter, sorting) {
        return axios.get('/api/partorders',
            {
                params: {
                    page: page,
                    status: filter.status,
                    partOrderNumber: filter.partOrderNumber,
                    serviceCompanyName: filter.serviceCompanyName,
                    purchaseOrderNumber: filter.purchaseOrderNumber,
                    sortBy: sorting.sortBy,
                    sortOrder: sorting.sortOrder
                }
            });
    },
    getOrder(id) {
        return axios.get(`/api/partorders/${id}`);
    },
    saveOrder(id, order) {
        var request = Object.assign({}, order);
        request.parts = request.parts.map(c => { return { id: c.id, quantity: c.quantity }; });
        if (request.selectedCountryState) {
            request.countryId = request.selectedCountryState[0];
            request.stateId = request.selectedCountryState[1];
            delete request.selectedCountryState;
        }

        if (id) {
            return axios.put(`/api/partorders/${id}`, request);
        }
        return axios.post('/api/partorders', request);
    },
    deleteOrder(id) {
        return axios.delete(`/api/partorders/${id}`);
    },
    getCategories() {
        return axios.get('/api/dashboard/categories/partorders');
    },
    printAndProcessOrder(id) {
        return axios.get(`/api/partorders/${id}/print`);
    },
    getOrderId() {
        return axios.get('/api/partorders/nextId');
    },
    exportOrderParts(id) {
        return axios.download(`/api/partorders/${id}/export`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/orders/api.js